import { render, staticRenderFns } from "./feishuGroupConfig.vue?vue&type=template&id=2d788328&scoped=true"
import script from "./feishuGroupConfig.vue?vue&type=script&lang=js"
export * from "./feishuGroupConfig.vue?vue&type=script&lang=js"
import style0 from "./feishuGroupConfig.vue?vue&type=style&index=0&id=2d788328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d788328",
  null
  
)

export default component.exports